module.exports = __webpack_public_path__ + "img/cash.3c2cb5e6.png";